import { atom } from 'jotai';
import { useAtomValue, useSetAtom } from 'jotai';
import { selectAtom } from 'jotai/utils';

const payloadAtom = atom<boolean>(false);

const isOpenAtom = selectAtom(payloadAtom, p => p);
export const useIsOpenExportLSUXmlTutoModal = () => useAtomValue(isOpenAtom);

const closeModalAtom = atom(null, (_, set) => set(payloadAtom, false));
export const useCloseExportLSUXmlTutoModal = () => useSetAtom(closeModalAtom);

const openModalAtom = atom(null, (_, set) => set(payloadAtom, true));
export const useOpenExportLSUXmlTutoModal = () => useSetAtom(openModalAtom);
